import Parse from 'html-react-parser';

function ColorMap(props) {
    let svgCode =
    `<svg width="16" height="9" viewBox="0 0 16 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="ColorMap">
        <path id="a2" d="M1 0H2V1H1V0Z" fill="black"/>
        <rect id="a3" x="2" width="1" height="1" fill="white"/>
        <rect id="a4" x="3" width="1" height="1" fill="${props.darkFill}"/>
        <rect id="a5" x="4" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="a6" x="5" width="1" height="1" fill="rgb(0,255,0)"/>
        <rect id="a7" x="6" width="1" height="1" fill="rgb(0,0,255)"/>
        <rect id="a8" x="7" width="1" height="1" fill="rgb(255,255,0)"/>
        <rect id="a9" x="8" width="1" height="1" fill="rgb(0,152,239)"/>
        <rect id="a10" x="9" width="1" height="1" fill="rgb(24,24,24)"/>
        <rect id="a11" x="10" width="1" height="1" fill="rgb(24,24,24)"/>
        <rect id="a12" x="11" width="1" height="1" fill="rgb(32,32,32)"/>
        <rect id="a13" x="12" width="1" height="1" fill="rgb(0,152,239)"/>
        <rect id="a14" x="13" width="1" height="1" fill="rgb(0,63,127)" fill-opacity="0.172549"/>
        <rect id="a15" x="14" width="1" height="1" fill="rgb(191,191,191)" fill-opacity="0.12549"/>
        <rect id="a16" x="15" width="1" height="1" fill="rgb(143,183,135)" fill-opacity="0.12549"/>
        <rect id="b1" y="1" width="1" height="1" fill="rgb(31,95,197)" fill-opacity="0.501961"/>
        <rect id="b2" x="1" y="1" width="1" height="1" fill="${props.envFill}"/>
        <rect id="b3" x="2" y="1" width="1" height="1" fill="rgb(155,123,63)" fill-opacity="0.25098"/>
        <rect id="b4" x="3" y="1" width="1" height="1" fill="rgb(16,32,48)"/>
        <rect id="b5" x="4" y="1" width="1" height="1" fill="${props.envFill}"/>
        <rect id="b6" x="5" y="1" width="1" height="1" fill="rgb(191,223,255)" fill-opacity="0.0313726"/>
        <rect id="b7" x="6" y="1" width="1" height="1" fill="rgb(42,58,68)"/>
        <rect id="b8" x="7" y="1" width="1" height="1" fill="rgb(198,226,255)" fill-opacity="0.0705882"/>
        <rect id="b9" x="8" y="1" width="1" height="1" fill="${props.envFill}" fill-opacity="0.301961"/>
        <rect id="b10" x="9" y="1" width="1" height="1" fill="${props.envFill}" fill-opacity="0"/>
        <rect id="b11" x="10" y="1" width="1" height="1" fill="${props.envFill}" fill-opacity="0.2"/>
        <rect id="b12" x="13" y="1" width="1" height="1" fill="rgb(21,21,21)"/>
        <rect id="b13" x="12" y="1" width="1" height="1" fill="${props.envFill}" fill-opacity="0.2"/>
        <rect id="b14" x="13" y="1" width="1" height="1" fill="rgb(21,21,21)"/>
        <rect id="b15" x="14" y="1" width="1" height="1" fill="rgb(231,231,231)" fill-opacity="0.0431373"/>
        <rect id="b16" x="15" y="1" width="1" height="1" fill="rgb(92,92,92)" fill-opacity="0.0431373"/>
        <rect id="c1" y="2" width="1" height="1" fill="rgb(208,208,208)" fill-opacity="0.0431373"/>
        <rect id="c2" x="1" y="2" width="1" height="1" fill="rgb(255,132,0)"/>
        <rect id="c3" x="2" y="2" width="1" height="1" fill="rgb(169,109,57)" fill-opacity="0.501961"/>
        <rect id="c4" x="3" y="2" width="1" height="1" fill="rgb(149,83,57)" fill-opacity="0.501961"/>
        <rect id="c5" x="4" y="2" width="1" height="1" fill="rgb(191,127,255)"/>
        <rect id="c6" x="5" y="2" width="1" height="1" fill="rgb(125,109,175)" fill-opacity="0.501961"/>
        <rect id="c7" x="6" y="2" width="1" height="1" fill="rgb(95,83,133)" fill-opacity="0.501961"/>
        <rect id="c8" x="7" y="2" width="1" height="1" fill="rgb(87,164,234)"/>
        <rect id="c9" x="8" y="2" width="1" height="1" fill="rgb(75,155,207)"/>
        <rect id="c10" x="9" y="2" width="1" height="1" fill="${props.highlightColour}"/>
        <rect id="c11" x="10" y="2" width="1" height="1" fill="${props.highlightColour}"/>
        <rect id="c12" x="11" y="2" width="1" height="1" fill="${props.highlightColour}"/>
        <rect id="c13" x="12" y="2" width="1" height="1" fill="rgb(127,127,127)"/>
        <rect id="c14" x="13" y="2" width="1" height="1" fill="rgb(86,95,102)"/>
        <rect id="c15" x="14" y="2" width="1" height="1" fill="rgb(30,34,38)"/>
        <rect id="c16" x="15" y="2" width="1" height="1" fill="rgb(53,53,53)" fill-opacity="0.501961"/>
        <rect id="d1" y="3" width="1" height="1" fill="rgb(183,224,255)" fill-opacity="0.0980392"/>
        <rect id="d2" x="1" y="3" width="1" height="1" fill="rgb(216,242,255)" fill-opacity="0.0784314"/>
        <rect id="d3" x="2" y="3" width="1" height="1" fill="rgb(92,255,135)"/>
        <rect id="d4" x="3" y="3" width="1" height="1" fill="rgb(92,255,134)" fill-opacity="0.498039"/>
        <rect id="d5" x="4" y="3" width="1" height="1" fill="rgb(38,87,74)"/>
        <rect id="d6" x="5" y="3" width="1" height="1" fill="${props.waveBG}"/>
        <rect id="d7" x="6" y="3" width="1" height="1" fill="${props.envFill}"/>
        <rect id="d8" x="7" y="3" width="1" height="1" fill="rgb(92,255,135)"/>
        <rect id="d9" x="8" y="3" width="1" height="1" fill="${props.waveBG}" fill-opacity="0.05"/>
        <rect id="d10" x="9" y="3" width="1" height="1" fill="${props.envFill}" fill-opacity="0.2"/>
        <rect id="d11" x="10" y="3" width="1" height="1" fill="rgb(38,87,74)"/>
        <rect id="d12" x="11" y="3" width="1" height="1" fill="${props.waveBG}" fill-opacity="0.2"/>
        <rect id="d13" x="12" y="3" width="1" height="1" fill="${props.envFill}" fill-opacity="0"/>
        <rect id="d14" x="13" y="3" width="1" height="1" fill="rgb(92,255,134)" fill-opacity="0.498039"/>
        <rect id="d15" x="14" y="3" width="1" height="1" fill="rgb(255,255,0)" fill-opacity="0.0784314"/>
        <rect id="d16" x="15" y="3" width="1" height="1" fill="rgb(67,138,12)"/>
        <rect id="e1" y="4" width="1" height="1" fill="rgb(130,182,8)"/>
        <rect id="e2" x="1" y="4" width="1" height="1" fill="rgb(26,30,33)"/>
        <rect id="e3" x="2" y="4" width="1" height="1" fill="rgb(47,54,58)"/>
        <rect id="e4" x="3" y="4" width="1" height="1" fill="rgb(177,210,11)"/>
        <rect id="e5" x="4" y="4" width="1" height="1" fill="rgb(0,150,255)"/>
        <rect id="e6" x="5" y="4" width="1" height="1" fill="rgb(27,55,98)"/>
        <rect id="e7" x="6" y="4" width="1" height="1" fill="rgb(127,127,127)"/>
        <rect id="e8" x="7" y="4" width="1" height="1" fill="rgb(0,0,255)"/>
        <rect id="e9" x="8" y="4" width="1" height="1" fill="rgb(127,127,127)"/>
        <rect id="e10" x="9" y="4" width="1" height="1" fill="rgb(236,231,224)"/>
        <rect id="e11" x="10" y="4" width="1" height="1" fill="rgb(154,58,15)"/>
        <rect id="e12" x="11" y="4" width="1" height="1" fill="rgb(182,93,14)"/>
        <rect id="e13" x="12" y="4" width="1" height="1" fill="rgb(82,190,252)"/>
        <rect id="e14" x="13" y="4" width="1" height="1" fill="rgb(20,23,25)"/>
        <rect id="e15" x="14" y="4" width="1" height="1" fill="rgb(26,29,30)"/>
        <rect id="e16" x="15" y="4" width="1" height="1" fill="rgb(28,32,34)"/>
        <rect id="f1" y="5" width="1" height="1" fill="rgb(32,36,39)"/>
        <rect id="f2" x="1" y="5" width="1" height="1" fill="rgb(65,73,79)"/>
        <rect id="f3" x="2" y="5" width="1" height="1" fill="rgb(17,20,21)"/>
        <rect id="f4" x="3" y="5" width="1" height="1" fill="rgb(30,34,38)"/>
        <rect id="f5" x="4" y="5" width="1" height="1" fill="rgb(255,255,0)"/>
        <rect id="f6" x="5" y="5" width="1" height="1" fill="rgb(207,208,208)"/>
        <rect id="f7" x="6" y="5" width="1" height="1" fill="${props.fontColour}"/>
        <rect id="f8" x="7" y="5" width="1" height="1" fill="rgb(31,88,0)"/>
        <rect id="f9" x="8" y="5" width="1" height="1" fill="rgb(127,127,127)"/>
        <rect id="f10" x="9" y="5" width="1" height="1" fill="rgb(26,115,199)"/>
        <rect id="f11" x="10" y="5" width="1" height="1" fill="rgb(53,53,53)" fill-opacity="0.490196"/>
        <rect id="f12" x="11" y="5" width="1" height="1" fill="rgb(8,53,89)" fill-opacity="0.490196"/>
        <rect id="f13" x="12" y="5" width="1" height="1" fill="rgb(142,142,142)" fill-opacity="0.490196"/>
        <rect id="f14" x="13" y="5" width="1" height="1" fill="rgb(0,142,240)" fill-opacity="0.490196"/>
        <rect id="f15" x="14" y="5" width="1" height="1" fill="rgb(119,119,255)" fill-opacity="0.392157"/>
        <rect id="f16" x="15" y="5" width="1" height="1" fill="rgb(249,249,0)" fill-opacity="0.392157"/>
        <rect id="g1" y="6" width="1" height="1" fill="rgb(68,68,140)" fill-opacity="0.392157"/>
        <rect id="g2" x="1" y="6" width="1" height="1" fill="rgb(140,140,0)" fill-opacity="0.392157"/>
        <rect id="g3" x="2" y="6" width="1" height="1" fill="rgb(7,53,89)" fill-opacity="0.392157"/>
        <rect id="g4" x="3" y="6" width="1" height="1" fill="rgb(0,142,239)" fill-opacity="0.392157"/>
        <rect id="g5" x="4" y="6" width="1" height="1" fill="rgb(53,61,77)" fill-opacity="0.501961"/>
        <rect id="g6" x="5" y="6" width="1" height="1" fill="rgb(53,77,61)" fill-opacity="0.501961"/>
        <rect id="g7" x="6" y="6" width="1" height="1" fill="rgb(41,63,17)"/>
        <rect id="g8" x="7" y="6" width="1" height="1" fill="rgb(221,221,221)" fill-opacity="0.352941"/>
        <rect id="g9" x="8" y="6" width="1" height="1" fill="rgb(83,83,83)" fill-opacity="0.27451"/>
        <rect id="g10" x="9" y="6" width="1" height="1" fill="rgb(163,163,163)" fill-opacity="0.27451"/>
        <rect id="g11" x="10" y="6" width="1" height="1" fill="black" fill-opacity="0.776471"/>
        <rect id="g12" x="11" y="6" width="1" height="1" fill="rgb(204,242,255)" fill-opacity="0.0784314"/>
        <rect id="g13" x="12" y="6" width="1" height="1" fill="rgb(26,30,33)"/>
        <rect id="g14" x="13" y="6" width="1" height="1" fill="rgb(20,23,25)"/>
        <rect id="g15" x="14" y="6" width="1" height="1" fill="rgb(91,191,255)"/>
        <rect id="g16" x="15" y="6" width="1" height="1" fill="rgb(127,127,127)" fill-opacity="0.501961"/>
        <rect id="h1" y="7" width="1" height="1" fill="rgb(10,21,31)" fill-opacity="0.188235"/>
        <rect id="h2" x="1" y="7" width="1" height="1" fill="${props.fontColour}" fill-opacity="0.0784314"/>
        <rect id="h3" x="2" y="7" width="1" height="1" fill="rgb(91,191,255)"/>
        <rect id="h4" x="3" y="7" width="1" height="1" fill="rgb(111,221,255)"/>
        <rect id="h5" x="4" y="7" width="1" height="1" fill="rgb(116,185,237)"/>
        <rect id="h6" x="5" y="7" width="1" height="1" fill="rgb(0,254,245)"/>
        <rect id="h7" x="6" y="7" width="1" height="1" fill="rgb(47,43,19)"/>
        <rect id="h8" x="7" y="7" width="1" height="1" fill="rgb(255,172,0)"/>
        <rect id="h9" x="8" y="7" width="1" height="1" fill="rgb(21,51,19)"/>
        <rect id="h10" x="9" y="7" width="1" height="1" fill="rgb(7,53,89)" fill-opacity="0.670588"/>
        <rect id="h11" x="10" y="7" width="1" height="1" fill="rgb(1,141,240)" fill-opacity="0.670588"/>
        <rect id="h12" x="11" y="7" width="1" height="1" fill="rgb(237,120,44)"/>
        <rect id="h13" x="12" y="7" width="1" height="1" fill="${props.fontColour}"/>
        <rect id="h15" x="14" y="7" width="1" height="1" fill="rgb(111,208,254)"/>
        <rect id="i1" y="8" width="1" height="1" fill="rgb(254,208,111)"/>
        <rect id="i2" x="1" y="8" width="1" height="1" fill="rgb(228,228,227)"/>
        <rect id="i3" x="2" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i4" x="3" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i5" x="4" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i6" x="5" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i7" x="6" y="8" width="1" height="1" fill="${props.highlightColour}"/>
        <rect id="i8" x="7" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i9" x="8" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i10" x="9" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i11" x="10" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i12" x="11" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i13" x="12" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i14" x="13" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i15" x="14" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
        <rect id="i16" x="15" y="8" width="1" height="1" fill="rgb(255,0,0)"/>
    </g>
    </svg>`

    props.svgReturn(0, svgCode, "colormap", 32, 18);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default ColorMap;



